<template>
  <div class="main-content queryBillPayment">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataBykeyWord"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper" style="min-height: 300px">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="billPaymentGrid.gridParams"
        :grid-options="billPaymentGrid.gridOptions"
        :column-defs="dynamicColumnDefs"
        :row-data="billPaymentGrid.rowData"
        :show-row-groups="dataListDragGroup"
      />
    </div>
    <div id="footer-wrapper-tab-billpayment" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['billPaymentList', 'Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyBillPaymentGrid.labelText" />
        <span v-if="dataShow && ['billPaymentList', 'Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyBillPaymentGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :type="totalType"
          :amount-to-currency="localCurrency"
          :data-field="totalDataField"
          :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
          :rate-field="rateField"
          :ar-field="arField"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['billPaymentList', 'Writeoff'].includes(viewSource)" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['billPaymentList', 'Writeoff'].includes(viewSource)"
          :key="2"
          :type="totalType"
          :amount-to-currency="localCurrency"
          data-field="unverifiedAmount"
          :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
          :rate-field="rateField"
          :ar-field="arField"
          :show-wht="showWht"
        />
      </div>
      <cargo-pagination
        ref="paginationBillPayment"
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <!-- 付款申请审批流 -->
    <bill-payment-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :bill-payment="workFlowApplyDialog.billPayment"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        fetchDataByPage()
      }"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants, { OPERATOR_EQUAL, OPERATOR_IN } from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { DocumentManage, Once, stringToBool } from '@/utils/commonUtil'
import { queryBillPaymentByJobList } from '@/api/clearing/billPayment'
import lodash from 'lodash'
import * as NumberUtils from '@/utils/NumberUtils'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import $store from '@/store'
import { queryJobNoLinkFunc } from '@/api/booking/job'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { BILL_PAYMENT } from '@/class/cargo/model/parameters/WorkflowConstants'
import BillPaymentWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/billPaymentApplyDialog'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'

export default {
  name: 'QueryBillPayment',
  components: { CargoAgGridWrapper, searchItem, chargeCurrencyTotalGroup, BillPaymentWorkFlowApplyDialog },
  props: {
    identify: { type: String, required: true, default: 'queryBillPayment' }, // ID
    viewSource: { type: String, required: true, default: 'billPaymentList' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    state: { type: Array, default: () => [] }, // 付款申请状态
    clearingStates: { type: Array, default: () => [] }, // 核销状态
    jobStates: { type: Array, default: () => [] }, // 业务状态
    isCheckCharge: { type: Boolean, default: false }, // 检查费用开票状态
    paidOff: { type: Number, default: -1 }, // 是否销账
    showInvoiceNoColumn: { type: Boolean, default: true }, // 是否显示对方发票号
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲销账结算单位
    jobStateParam: { type: String, default: 'BillPaymentJobState' }, // BillPaymentJobState, 付款申请-费用-业务状态查询(付款申请)
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'converRate' }, // 汇率字段
    arField: { type: String, default: 'ar' }, // 收付字段
    type: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '508' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190801' }, // 列表设置
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '付款申请查询',
      // configModule: '505',
      simQueryPlaceholder: '快捷检索:付款申请号',
      perConfigName: '',
      gridRefreshId: 0,
      billPaymentGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected,
          onRowClicked: this.onRowClicked,
          onRowDoubleClicked: this.onRowDoubleClicked
        },
        rowData: []
      },
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        requires: ['voucherNoCreateDate', 'targetVoucherNo'],
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        jobStates: [] // 业务状态
      },
      totalAmountToCurrencyBillPaymentGrid: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        dataProvider: [], // 数据源
        selectedCount: 0 // 选中条数
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      queryOfficeId: 0, // 记录查询时的分公司Id
      isBpmEnabled: false,
      workFlowApplyDialog: {
        visible: false
      },
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      documentManage: new DocumentManage()
    }
  },
  computed: {
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    dynamicColumnDefs() {
      const dynamicColumnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Payment.billPaymentNo'), field: 'billPaymentNo', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.settleAccountsTo'), field: 'accountId', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
          }
        },
        {
          headerName: this.$t('Payment.settlementAgent'), field: 'settlementAgentId', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            if (params.value === 0) {
              return ''
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'customerId', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },

        // {
        //   headerName: this.$t('Payment.businessNumber'),
        //   field: 'jobNo',
        //   width: 200,
        //   cellRendererFramework: 'agGridColumnEdit',
        //   custom: {
        //     tag: 'multi-router-and-print',
        //     attrs: params => {
        //       const data = params.data
        //       return {
        //         useRoute: true,
        //         usePrint: true,
        //         jumpMethod: value => {
        //           jumpFinaceOrBusiness(this, value, '', data.branchId)
        //         },
        //         printMethod: this.toJumpFinanceManage
        //       }
        //     }
        //   }
        // },

        // CARGO-33759 【付款申请】模块，付款申请号里存在多个费用业务编号，全部展示 由原先的jobNo展示一个业务编号调整为jobNos能展示多个业务编号
        {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNos',
          // enableRowGroup: true,
          cellRendererFramework: 'agGridColumnEdit',
          enableRowGroup: true,
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: true,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                },
                printMethod: this.toJumpFinanceManage
              }
            }
          },
          width: 200
        },
        {
          headerName: this.$t('Payment.dateOfApplication'),
          field: 'inputDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.applicant'), field: 'inputBy', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.applicationDepartment'), field: 'inputByDep', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.departmentLabelNewFunc(Number(params.value)) : ''
          }
        },
        {
          headerName: this.$t('Payment.paymentPeriod'), field: 'deadline', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.methodOfPayment'), field: 'payType', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.amountReceiveTypeLabelFun(Number(params.value))
          }
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNos', width: 200, hide: !this.showInvoiceNoColumn, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.invoiceHeader'),
          field: 'invoiceTitle',
          width: 300,
          enableRowGroup: true,
          filterParams: {},
          filterValueGetter: (params) => params.data?.invoiceTitle || ''
        },
        {
          headerName: this.$t('Payment.lackInvoiceFlag'),
          field: 'lackInvoiceFlag',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const v = params.value
            // 是否缺票标记：0 无票，1 有票
            if (v === 1 || v === '1' || v === true) {
              return this.$t('constant.no')
            }
            if (v === 0 || v === '0' || v === false) {
              return this.$t('constant.yes')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Payment.uploadAttachmentFlag'),
          field: 'uploadAttachmentFlag',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            const v = params.value
            // 是否上传附件：0 未上传，1 已上传
            if (v === 1 || v === '1' || v === true) {
              return this.$t('constant.yes')
            }
            if (v === 0 || v === '0' || v === false) {
              return this.$t('constant.no')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Payment.currency'), field: 'currency', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.amount'), field: 'amount', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          summaryMode: 'sum'
        },
        // {
        //   headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200,
        //   cellRenderer: (params) => {
        //     return params.value === 0 ? '' : NumberUtils.formatRoundNumber(params.value, 2)
        //   },
        //   hide: !this.showVerifiedAmount
        // },
        {
          headerName: this.$t('Payment.currencyAmountOfWriteOffs'), field: 'currencyVerifiedAmount', width: 200, hide: !this.showVerifiedAmount, enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('WriteOff.approvalStatus'),
          field: 'state',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('WriteOff.businessAuditor'), field: 'businessVerifier', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.businessAuditDate'), field: 'businessVerifyDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.financialAuditor'), field: 'financeVerifier', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.financialAuditDate'), field: 'financeVerifyDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.verificationStatus'), field: 'realClearingState', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          },
          hide: !this.showRealClearingState
        },
        {
          headerName: this.$t('Payment.remarks'), field: 'remark', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('queryJob.placeOfDelivery'),
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('Payment.mbl'),
          field: 'mbl',
          width: 200,
          enableRowGroup: true,
          cellRendererFramework: 'CargoGridShowBigContent',
          tooltipValueGetter: () => {},
          hide: true
        },
        /*, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.getUserDefinedLabel(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.getUserDefinedLabel(params.value)
          }
        }*/
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxLocalAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'), field: 'notWhtAmount', width: 100,
          hide: !this.showWhtTax,
          enableRowGroup: true,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Partners.paymentType'), field: 'paymentType', width: 200, enableRowGroup: true, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', params.value, 'name')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const paymentType = params.data.paymentType
            if (paymentType === '' || paymentType === undefined) {
              return ''
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', paymentType, 'name')
          }
        },
        {
          headerName: 'SERVICE',
          field: 'whtService',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'ADVANCE',
          field: 'whtAdvance',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'VAT',
          field: 'whtVat',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('FinanceManage.CostType'),
          colId: 'costType',
          field: 'costType',
          width: 180,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('CargoMsg.Cargo_PaidP') : this.$t('CargoMsg.Cargo_SimpleUnpaidP')
          },
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrintOrNot'),
          colId: 'hasPrint',
          field: 'hasPrint',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        }
      ]
      if (this.isBpmEnabled) {
        dynamicColumnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      return dynamicColumnDefs
    },
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyBillPaymentGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await this.initCustomSearchItems()
    this.setLocalCurrency()
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, '', documentProcessId)
    })
  },
  mounted() {
    // this.scrollCallback()
    // document.querySelector('.queryBillPayment').addEventListener('scroll', this.scrollCallback)
  },
  methods: {
    // 配置参数
    async initConfig() {
      const jobStates = []
      if (this.jobStateParam) {
        this.searchConditions.jobStateParam = String(cache.config.get(this.jobStateParam))
        //
        this.searchConditions.jobStateParam.split(',').forEach(function(value) {
          jobStates.push(Number(value))
        })
      }
      this.searchConditions.jobStates = jobStates
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: BILL_PAYMENT.code,
        officeId: this.$store.getters.currentOfficeId
      })
    },
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      const advConditions = lodash.cloneDeep(conditions)
      let conPaidOff = -1
      conditions.forEach(function(item) {
        if (item.fieldName === 'billPayment.STATE' && item.value === -1) {
          conPaidOff = 0
        }
        if (item.fieldName === 'billPayment.STATE' && item.value === 1) {
          item.value = [1, 6]
          item.operator = 'IN'
          finallyConditions.push(item)
        }
      })
      // 是否核销
      if (conPaidOff > -1) {
        const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', conPaidOff, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 业务状态
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(conditions, "job.JOB_STATE'")) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 是否查询受控费用
      if (!this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      if (this.exceptKeys.length > 0) {
        const option = new AdvancedSearchOption(null, 'billPayment.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.exceptAdvancedSearchOption) {
        finallyConditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
      }
      if (this.selectedEntitiesForHedging.length > 0) {
        const option = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.showVerifiedAmount || this.showRealClearingState) { this.searchConditions.requires.push('writeoff') }
      if (this.showInvoiceNoColumn) { this.searchConditions.requires.push('invoiceNo') }
      if (this.isCheckCharge) { this.searchConditions.requires.push('checkCharge') }
      if (this.showWhtTax) { this.searchConditions.requires.push('whtTax') }

      advConditions.forEach(function(item) {
        if (!((conPaidOff > -1 || item.value === 1) && item.fieldName === 'billPayment.STATE')) {
          finallyConditions.push(item)
        }
      })
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('billPayment.ACCOUNTID', conditions)) {
        const option = new AdvancedSearchOption(null, 'billPayment.ACCOUNTID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryBillPaymentList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        this.searchConditions.pageNum = 1
        const conditions = []
        const option = new AdvancedSearchOption(null, 'billPayment.BILLPAYMENTNO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        if (conditions.length > 0) {
          this.fetchData(conditions, true)
        }
      }
    },
    // 分页触发查询
    fetchDataByPage(param) {
      this.toQueryBillPaymentList()
    },
    toQueryBillPaymentList(data) {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires, pageNum, pageSize } = this.searchConditions
      if (this.isBpmEnabled) {
        requires.push('bpm')
      }
      // 创建申请付款保存之后单独处理列表数据
      if (data) {
        const uuid = data.uuid
        const option = new AdvancedSearchOption(null, 'billPayment.UUID', uuid, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
        const pageNum = 1
        const pageSize = 10
        const request = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize }
        this.loading = getLoading()
        queryBillPaymentByJobList(request).then(res => {
          if (res.data.list && res.data.list.length > 0) {
            if (this.billPaymentGrid.rowData && this.billPaymentGrid.rowData.length > 0) {
              const resItem = res.data.list[0]
              // 检查当前数据在之前的数组中是否存在
              const isContains = this.billPaymentGrid.rowData.every(item => item.uuid !== resItem.uuid)
              if (isContains) {
                this.searchConditions.total++
              } else {
                // 更新操作需要把之前的移除付款申请单
                this.billPaymentGrid.rowData.forEach((data, index) => {
                  if (data.uuid === resItem.uuid) {
                    this.billPaymentGrid.rowData.splice(index, 1)
                  }
                })
              }
              this.billPaymentGrid.rowData.unshift(...res.data.list)
            } else {
              this.searchConditions.total = Number(res.data.total)
              this.billPaymentGrid.rowData = res.data.list
            }
          }
          // 移除查询条件
          const index = conditions.findIndex(obj => obj.fieldName === 'billPayment.UUID')
          if (index !== -1) {
            conditions.splice(index, 1)
          }
        }).catch(() => {
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
        return
      }
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize }
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.billPaymentGrid.gridOptions.api, 'uuid')
      queryBillPaymentByJobList(requestBody).then(res => {
        if (res.data.list && res.data.list.length > 0) {
          this.billPaymentGrid.rowData = res.data.list
          this.searchConditions.total = Number(res.data.total)
          if (this.isAr === -1) {
            const all = $store.getters.language === 'zh' ? '全部' : 'ALL'
            this.totalAmountToCurrencyBillPaymentGrid.labelText = '(' + all + ')'
          } else if (this.isAr === 0 || this.isAr === 1) {
            this.totalAmountToCurrencyBillPaymentGrid.labelText = '(' + ColumnUtils.chargeReceivableLabelFun(this.isAr) + ')'
          }
          this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
          this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.billPaymentGrid.rowData
          this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
        } else {
          this.billPaymentGrid.rowData = []
          this.searchConditions.total = 0
          this.totalAmountToCurrencyBillPaymentGrid.labelText = ''
          this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
          this.totalAmountToCurrencyBillPaymentGrid.dataProvider = []
          this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
        }
        this.$emit('dataProviderChange', { data: this.billPaymentGrid.rowData, searchConditions: this.searchConditions })
        selectedStatus.revert()
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    //
    async initCustomSearchItems() {
      // 业务状态
      const defaultSearchFields = []
      let jobStates = []
      if (this.jobStateParam) {
        jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES)
      }
      const searchField = new AdvancedSearchField()
      searchField.action = 2
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemValue = []
      searchField.itemLabel = 'Billing.billingCharge_businessStatus'
      searchField.itemName = 'job.JOB_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = jobStates
      defaultSearchFields.push(searchField.formatObj2Json())
      // 默认结算单位
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'WriteOff.settleAccountsTo'
          searchField.itemName = 'billPayment.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 申请日期
      if (this.viewSource === 'Writeoff') {
        let searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'billPayment.INPUTDATE'
        searchField.itemLabel = 'WriteOff.dateOfApplication'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否已核销
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.PAID_OFF'
        searchField.itemLabel = 'WriteOff.wroteOffOrNot'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 最晚开票日期
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'lidCharge.lastInvoiceDate'
        searchField.itemLabel = 'Payment.lastInvoicingDate'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      {
        const removeField = new AdvancedSearchField()
        removeField.action = AdvancedSearchField.REMOVE_ACTION
        removeField.itemName = 'billPayment.INVOICE_TITLE'
        removeField.fieldType = 'FIELD_DROP_DOWN_LIST'
        defaultSearchFields.push(removeField.formatObj2Json())
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.lock = false
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'billPayment.INVOICE_TITLE'
        searchField.itemLabel = 'Payment.invoiceHeader'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      this.customSearchItems = defaultSearchFields
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    getSelections() { // 获取勾选的项目
      return getGridSelected(this.billPaymentGrid.gridOptions)
    },
    updateRowDataInformation(dataArray = null) { // 修改列表的属性
      const rowData = this.billPaymentGrid.rowData
      if (dataArray) {
        for (const billPayment of rowData) {
          for (const item of rowData) {
            if (item.uuid && billPayment.uuid && item.uuid === billPayment.uuid) {
              Object.assign(billPayment, item)
            }
          }
        }
      }
    },
    changeDataProvider(rowData = [], searchConditions = {}) { // 修改列表数据源以及查询条件
      this.billPaymentGrid.rowData = rowData
      this.searchConditions = searchConditions
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      console.log('toRefreshSelectedCountChargeGrid', event)
      this.filterChange()
      // this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
    },
    filterChange() {
      const selections = getGridSelected(this.billPaymentGrid.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          this.loading = getLoading()
          const hasDisplay = []
          this.billPaymentGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.billPaymentGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.billPaymentGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, this.billPaymentGrid.rowData], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, this.billPaymentGrid.rowData], 200)
          }
          this.loading.close()
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyBillPaymentGrid.labelText = ''
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = '选中 ' + selections.length + '：'
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrencyBillPaymentGrid.labelText = '全部'
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillPaymentGrid.labelText = '全部'
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.billPaymentGrid.rowData
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-billpayment')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    // 刷新列表数据
    refreshRowData(billPayments = []) {
      if (billPayments && billPayments.length > 0 && this.billPaymentGrid.rowData.length > 0) {
        let update = false
        for (const billPayment of billPayments) {
          for (const item of this.billPaymentGrid.rowData) {
            if (item['uuid'] && billPayment['uuid'] && billPayment['uuid'] === item['uuid']) {
              update = true
              item['state'] = billPayment['state']
              break
            }
          }
        }
        if (update) {
          this.billPaymentGrid.gridOptions.api.refreshCells({ force: true })
        }
      }
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationBillPayment.realtotal = realtotal
    },
    // 跳转至财务审核
    toJumpFinanceManage(value) {
      if (value) {
        queryJobNoLinkFunc({ jobNo: value }).then(res => {
          const data = res.data
          if (data && data.lob) {
            if (data.lob === 'AI') {
              if (!this.$checkPermission(['module_AIBooking'])) {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
              this.$router.push({ name: 'AiBooking', params: { jobNo: data.jobNo }})
            } else if (data.lob === 'AE') {
              if (!this.$checkPermission(['module_AEBooking'])) {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
              this.$router.push({ name: 'AeBooking', query: { jobNo: data.jobNo }})
            } else if (data.lob === 'SI') {
              if (!this.$checkPermission(['module_SIBOOKING'])) {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
              this.$router.push({ name: 'SiBooking', params: { jobNo: data.jobNo }})
            } else if (data.lob === 'SE') {
              if (!this.$checkPermission(['module_fmBookingNew'])) {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
              this.$router.push({ name: 'SeaBooking', query: { jobNo: data.jobNo }})
            } else if (data.lob === 'RE' || data.lob === 'RI') {
              if (!this.$checkPermission(['module_RailwayExport'])) {
                this.$message.warning(this.$t('CargoMsg.Cargo_NoPermissionForModule'))
                return
              }
              this.$router.push({ name: 'ReBooking', query: { jobNo: data.jobNo }})
            }
          }
        })
      }
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.queryBillPayment{
    display: flex;
    flex-direction: column;
    flex: 1;
  .row-grid{
    min-height: 500px;
    flex: 1
  }
}
</style>
